import './App.css';
import Home from './Home';

function App() {

  return (
      <Home>

      </Home>
  );
}

export default App;